import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {RouterProvider} from 'react-router/dom'
import {StyleProvider} from '@ant-design/cssinjs'
import {ConfigProvider} from 'antd'
import {Routes} from './Routes/Routes'
import './index.css'
import {Provider} from 'react-redux'
import {store} from './Redux/store'
import {Toaster} from 'react-hot-toast'
import SocketContext from './Context/SocketContext'

createRoot(document.getElementById('root')).render(
    <StrictMode>
        {/* StyleProvider(layer) emits antd CSS into @layer antd so it coexists
            predictably with Tailwind v4's layers (see @layer order in index.css).
            ConfigProvider must wrap the children for antd icon styles. */}
        <StyleProvider layer>
            <ConfigProvider
                theme={{
                    components: {
                        Modal: {
                            borderRadiusLG: 14,
                            titleFontSize: 18,
                            titleColor: 'var(--text)',
                        },
                        Menu: {
                            darkItemBg: 'transparent',
                            darkSubMenuItemBg: 'transparent',
                            darkPopupBg: '#242424',
                            darkItemColor: 'rgba(254,254,254,0.85)',
                            darkItemHoverBg: 'rgba(254,254,254,0.12)',
                            darkItemSelectedBg: '#FEFEFE',
                            darkItemSelectedColor: '#242424',
                            itemBorderRadius: 8,
                            itemMarginInline: 8,
                            iconSize: 18,
                        },
                    },
                }}
            >
                <Provider store={store}>
                    <SocketContext>
                        <RouterProvider router={Routes}/>
                        <Toaster
                            position="top-center"
                        />
                    </SocketContext>
                </Provider>
            </ConfigProvider>
        </StyleProvider>
    </StrictMode>,
)
